<template>
    <div>
        <div class="about-banner">
            <img :src="mainimg" />
            <div class="about-banner-word">
                <span>主营业务 Main Business</span>
                <img src="../assets/img/fb.png" @click="changeAboutNav" />
            </div>
        </div>
        <!-- 导航 -->
        <div class="about-nav-bg" v-if="isShowNav"></div>
        <div class="about-nav" v-if="isShowNav">
            <div class="top-nv">
                <span>主营业务</span>
                <img src="../assets/img/close.png" @click="closeAboutNav" />
            </div>
            <div class="about-nv-content">
                <ul>
                    <li @click="toBusiness(index)" v-for="(item,index) in menu_active" :key="index">
                        <a>{{item.title}}</a>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 导航 结束 -->
        <!-- start -->
        <div class="tab-card" style="display:block;">
            <div class="about-title">
                直管公房经营管理
            </div>
            <div class="manage-vocational-outer" v-for="(item,index) in mass1" :key="index" @click="toDetail(item.business_id)">
                <div class="manage-vocational">
                    <img :src="baseUrl+item.cover" />
                    <div>
                        <h3>{{item.company_name}}</h3>
                        <ul>
                            <li>负责人: 张小欢</li>
                            <li>电  话：{{item.phone}}</li>
                            <li>地   址: {{item.address}}</li>
                        </ul>
                    </div>
                </div>
                <div class="manage-vocational-info">
                    业务范围：{{item.desc}}
                </div>
            </div>
        </div>
        <!-- end -->

        <!-- start -->
        <div class="tab-card" style="display:none;">
            <div class="about-title">
                综合性物业管理服务
            </div>
            <div class="manage-vocational-outer" v-for="(item,index) in mass2" :key="index" @click="toDetail(item.business_id)">
                <div class="manage-vocational">
                    <img :src="baseUrl+item.cover" />
                    <div>
                        <h3>{{item.company_name}}</h3>
                        <ul>
                            <li>负责人: 张小欢</li>
                            <li>电  话：{{item.phone}}</li>
                            <li>地   址: {{item.address}}</li>
                        </ul>
                    </div>
                </div>
                <div class="manage-vocational-info">
                    业务范围：{{item.desc}}
                </div>
            </div>
        </div>
        <!-- end -->

        <!-- start -->
        <div class="tab-card" style="display:none;">
            <div class="about-title">
                老城保护复兴业务
            </div>
            <div class="manage-vocational-outer" v-for="(item,index) in mass3" :key="index" @click="toDetail(item.business_id)">
                <div class="manage-vocational">
                    <img :src="baseUrl+item.cover" />
                    <div>
                        <h3>{{item.company_name}}</h3>
                        <ul>
                            <li>负责人: 张小欢</li>
                            <li>电  话：{{item.phone}}</li>
                            <li>地   址: {{item.address}}</li>
                        </ul>
                    </div>
                </div>
                <div class="manage-vocational-info">
                    业务范围：{{item.desc}}
                </div>
            </div>
        </div>
        <!-- end -->

        <!-- start -->
        <div class="tab-card" style="display:none;">
            <div class="about-title">
                综合服务业务
            </div>
            <div class="manage-vocational-outer" v-for="(item,index) in mass4" :key="index" @click="toDetail(item.business_id)">
                <div class="manage-vocational">
                    <img :src="baseUrl+item.cover" />
                    <div>
                        <h3>{{item.company_name}}</h3>
                        <ul>
                            <li>负责人: 张小欢</li>
                            <li>电  话：{{item.phone}}</li>
                            <li>地   址: {{item.address}}</li>
                        </ul>
                    </div>
                </div>
                <div class="manage-vocational-info">
                    业务范围：{{item.desc}}
                </div>
            </div>
        </div>
        <!-- end -->

        <!-- start -->
        <div class="tab-card" style="display:none;">
            <div class="about-title">
                法规文件
            </div>
            <div class="news-list">
                <a href="javascript:;" v-for="(item,index) in fgwj_li" :key="index" @click="toDetail(item.business_id)"><h3>{{item.title}}</h3> <span>{{item.addtime}}</span></a>
            </div>
        </div>
        <!-- end -->
    </div>    
</template>

<script>
export default {
    data(){
        return{
            baseUrl:'',
            mainimg:require('../assets/img/business.png'),
            menu_active: [
                {
                    title: '直管公房经营管理',
                    link: '',
                    isActive: true,
                },
                {
                    title: '综合性物业管理服务',
                    link: '',
                    isActive: false,
                },
                {
                    title: '老城保护复兴业务',
                    link: '',
                    isActive: false,
                },
                {
                    title: '综合服务业务',
                    link: '',
                    isActive: false,
                },
                {
                    title: '法规文件',
                    link: '',
                    isActive: false,
                }
            ],
            model1: {
                type: 1,
            },
            mass1: '',
            model5: {
                //法规文件
                page: '',
            },
            fgwj_li: '',
            model2: {
                type: 2,
            },
            model3: {
                type: 3,
            },
            model4: {
                type: 4,
            },
            mass2: '',
            mass3: '',
            mass4: '',
            isShowNav:false,
        }
    },
    methods:{
        changeAboutNav:function(){
            this.isShowNav=true;
        },
        closeAboutNav:function(){
            this.isShowNav=false;
        },
        toBusiness:function(index){
            var that=this;
            var tabCardCollection = document.querySelectorAll(".tab-card"),
                    len = tabCardCollection.length;
                for (var i = 0; i < len; i++) {
                    tabCardCollection[i].style.display = "none";
                }
                tabCardCollection[index].style.display = "block";
                that.isShowNav = false;
        },
        toDetail:function(new_id){
            this.$router.push({
                name: 'businessDetail',
                params: {
                    business_id: new_id
                }
            })
        },
        getData: function(){
            var that = this;
            //
            that.$http.post(that.baseUrl+that.config.Mass,that.$qs.stringify(that.model1)).then(function(ev){
                console.log(ev);
                if(ev.data.code == 100){
                    that.mass1 = ev.data.data;
                }
            }).catch(function(error){
                console.log(error);
            })
            //法规文件
            that.$http.post(that.baseUrl+that.config.laws,that.$qs.stringify(that.model5)).then(function(ev){
                 console.log(ev);
                if(ev.data.code == 100){
                    that.fgwj_li = ev.data.data.data;
                }
            }).catch(function(error){
                console.log(error);
            })
            //综合性物业管理服务
            that.$http.post(that.baseUrl+that.config.Mass,that.$qs.stringify(that.model2)).then(function(ev){
                if(ev.data.code == 100){
                    that.mass2 = ev.data.data;
                }
            }).catch(function(error){
                console.log(error);
            })
            //老城
            that.$http.post(that.baseUrl+that.config.Mass,that.$qs.stringify(that.model3)).then(function(ev){
                if(ev.data.code == 100){
                    that.mass3 = ev.data.data;
                }
            }).catch(function(error){
                console.log(error);
            })
            //综合业务
            that.$http.post(that.baseUrl+that.config.Mass,that.$qs.stringify(that.model4)).then(function(ev){
                if(ev.data.code == 100){
                    that.mass4 = ev.data.data;
                }
            }).catch(function(error){
                console.log(error);
            })
        },
    },
    mounted(){
        this.baseUrl = window.baseUrl;
        this.config = window.config;
        this.getData();
    }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Business.vue